import { render } from "./LayOut.vue?vue&type=template&id=6a900496&scoped=true"
import script from "./LayOut.vue?vue&type=script&lang=js"
export * from "./LayOut.vue?vue&type=script&lang=js"

import "./LayOut.vue?vue&type=style&index=0&id=6a900496&lang=scss&scoped=true"

import exportComponent from "E:\\WORKING\\0004-WEB\\RD_Management\\rd_notepad_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a900496"]])

export default __exports__